import { connect } from 'react-redux';
import ArcadeRoomList from './List';
import { getArcadeRoomsRooms } from '../selectors';
import { 
    getArcadeRooms, 
    getArcadeRoom,
    deleteArcadeRoom
} from '../actions';
import { getArcadeMainRoomId } from 'arcade/sections/arcade/selectors';

const mapStateToProps = state => ({
    rooms: getArcadeRoomsRooms(state),
    mainRoomId: getArcadeMainRoomId(state)
});

const mapDispatchToProps = { 
    getArcadeRooms, 
    getArcadeRoom,
    deleteArcadeRoom
};


export default connect(mapStateToProps, mapDispatchToProps)(ArcadeRoomList);
